export interface FilterParams {
  isAssistedSale?: boolean
  storeSlug?: string | null
  region: string
  categoryPageId?: string
}

export function getFilters({
  isAssistedSale,
  storeSlug,
  region,
  categoryPageId
}: FilterParams) {
  if (isAssistedSale) {
    return storeSlug ? `store_${storeSlug}.isVisibleOnRegion:true` : undefined
  }

  const regionalFilter = `regionalAttributes.${region}.promotionalPrice > 0 AND regionalAttributes.${region}.available=1 AND regionalAttributes.${region}.stock.hasStock=1`

  if (categoryPageId) {
    return `${regionalFilter} AND ${categoryPageId}`
  }

  return regionalFilter
}
